/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect} from 'react'
import SearchableSelect from '../../../../components/SearchableSelect/SearchableSelect'
import {Option} from '../../../../models/Sektor'
import {getDebljinePanela} from '../../../../api/panelDebljina'

//  Props for the component
interface DropdownProps {
  value?: string | number
  initialValue?: string | number
  onChange?: (name: string, value: any) => void
  errors?: string | undefined
  touched?: boolean
  selectName?: string
}

const PanelDebljinaDropdown: React.FC<DropdownProps> = ({
  value,
  initialValue,
  onChange,
  errors,
  touched,
  selectName,
}) => {
  const [PanelDebljina, setPanelDebljina] = useState<Array<Option>>([])
  const internalValue = initialValue ?? null

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getDebljinePanela()
        setPanelDebljina(mapData(response.data))
      } catch (error) {
        console.error('Error fetching dropdown data:', error)
      }
    }
    fetchData()
  }, [])

  const finalValue = value ?? internalValue

  const mapData = (data) => {
    if (!data) {
      return []
    }
    return data.map((item) => ({label: item.debljina, value: item.id.toString()}))
  }

  return (
    <SearchableSelect
      options={PanelDebljina}
      value={finalValue?.toString() ?? ''}
      onChange={onChange!}
      name={selectName ?? 'PanelDebljina'}
      errors={errors}
      placeholder='Odaberi panel Obloga.'
      touched={touched}
    />
  )
}

export default PanelDebljinaDropdown
